import { render, staticRenderFns } from "./LoadApp.vue?vue&type=template&id=6fbcffaa&scoped=true"
import script from "./LoadApp.vue?vue&type=script&lang=js"
export * from "./LoadApp.vue?vue&type=script&lang=js"
import style0 from "./LoadApp.vue?vue&type=style&index=0&id=6fbcffaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbcffaa",
  null
  
)

export default component.exports